"use client"
import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from "@iconify/react";
import { updateShowOnSignUp } from './userType.service';
import { resultMessage } from '../../../../service/apiResult';
import {
    confirmationDialogSx,
    confirmationIconSx,
    confirmationPrimaryButtonSx,
    confirmationSecondaryButtonSx,
    confirmationTextSx,
    confirmationTitleSx,
} from '../../../styles/dialogStyles';

export default function SignupModal(props) {

    const { onClose, getUserTypeData, selectedId, showOnSignUp, setResponseMsg, setAlert, setOpenAlert, setLoading, ALERT_DURATION, alertClose, setActionError } = props;

    const onSubmit = async (e) => {
        e.preventDefault();
        const newValue = !showOnSignUp;
        setLoading(true)
        const res = await updateShowOnSignUp(selectedId, newValue);
        setLoading(false);

        if (!res.success) {
            // Refusals stay on the page until dismissed rather than sliding away in a toast.
            setActionError(resultMessage(res));
            onClose();
            return;
        }

        setActionError('');
        // The endpoint returns the updated persona, not a message, so the wording is ours.
        setResponseMsg(resultMessage(res, 'Signup visibility updated successfully'));
        setAlert('true');
        setOpenAlert(true);
        setTimeout(() => {
            alertClose();
            getUserTypeData();
            onClose();
        }, ALERT_DURATION);
    };

    const message = showOnSignUp
        ? 'Hide this user persona from eKutir signup?'
        : 'Show this user persona in eKutir signup?';

    return (
        <Box sx={confirmationDialogSx}>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
                <Button onClick={onClose} sx={{ minWidth: 'auto', p: 0.5, color: '#6B7280', borderRadius: '999px' }}>
                    <CloseIcon data-testid="cancel-icon" />
                </Button>
            </Stack>
            <form onSubmit={onSubmit}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                    <Box sx={confirmationIconSx}>
                        <Icon icon="mingcute:warning-line" width="36" height="36" color="#C40000" />
                    </Box>
                    <Typography sx={confirmationTitleSx}>Warning!</Typography>
                    <Typography sx={confirmationTextSx}>{message}</Typography>
                    <Stack direction="row" spacing={1.5} justifyContent="center" sx={{ pt: 1 }}>
                        <Button variant="contained" type="submit" sx={confirmationPrimaryButtonSx}>Yes</Button>
                        <Button onClick={onClose} sx={confirmationSecondaryButtonSx}>No</Button>
                    </Stack>
                </Stack>
            </form>
        </Box>
    )
}
